import React, { useState } from "react";
import { Criterias, Proposal, ProposalByProperty } from "rsl-api-106/lib/types";

import { SearchContext } from "@contexts";

export const SearchProvider: React.FC = ({ children }) => {
  const [proposals, setProposals] =
    useState<ProposalByProperty[] | Proposal[] | null>(null);
  const [criterias, setCriterias] = useState<Criterias | null>(null);

  const [isSearching, setIsSearching] = useState<boolean>(false);

  return (
    <SearchContext.Provider
      value={{
        proposals,
        setProposals,
        criterias,
        setCriterias,
        isSearching,
        setIsSearching,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
